import React from 'react';
import LegalLayout from './LegalLayout';
import { Card, CardContent } from '../../../components/ui/card';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import './legal.css';

const ContactUs = () => (
  <LegalLayout title="Contact Us">
    <div className="prose max-w-none">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact SmushLabs</h2>
      <p className="text-gray-600 mb-8">
        These are the official ways to contact SmushLabs.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <Card><CardContent className="p-6">
          <Mail className="h-6 w-6 text-green-600 mb-3" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Customer Support</h3>
          <a className="text-green-700 font-medium" href="mailto:support@smushlabs.ai">support@smushlabs.ai</a>
        </CardContent></Card>
        <Card><CardContent className="p-6">
          <Mail className="h-6 w-6 text-blue-600 mb-3" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Business Enquiries</h3>
          <a className="text-blue-700 font-medium" href="mailto:hello@smushlabs.ai">hello@smushlabs.ai</a>
        </CardContent></Card>
        <Card><CardContent className="p-6">
          <Mail className="h-6 w-6 text-purple-600 mb-3" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Founder</h3>
          <a className="text-purple-700 font-medium" href="mailto:asif@smushlabs.ai">asif@smushlabs.ai</a>
        </CardContent></Card>
        <Card><CardContent className="p-6">
          <Phone className="h-6 w-6 text-blue-600 mb-3" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Phone</h3>
          <a className="text-blue-700 font-medium" href="tel:+917892635932">+91 78926 35932</a>
        </CardContent></Card>
        <Card><CardContent className="p-6">
          <MapPin className="h-6 w-6 text-purple-600 mb-3" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Registered address</h3>
          <address className="not-italic text-gray-600">Tulsi 117, Sunderban Phase 2 Tulsi<br />Dimna Pardih Road, Mango<br />Jamshedpur, East Singhbhum<br />Jharkhand 831012, India</address>
        </CardContent></Card>
        <Card><CardContent className="p-6">
          <Clock className="h-6 w-6 text-gray-600 mb-3" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Support hours</h3>
          <p className="text-gray-600">Monday-Friday, 12:30 AM-7:30 AM EST</p>
        </CardContent></Card>
      </div>
    </div>
  </LegalLayout>
);

export default ContactUs;
